import { createSelector } from "@reduxjs/toolkit"

const selectBase = createSelector(
	(state: RootState) => state,
	state => state.options
)

export const selectCompanyLogo = createSelector(selectBase, state => state.companyLogo)
export const selectCompanyName = createSelector(selectBase, state => state.companyName)
export const selectCompanyAddress = createSelector(selectBase, state => state.companyAddress)
export const selectCompanyPhone = createSelector(selectBase, state => state.companyPhone)
export const selectWorkTime = createSelector(selectBase, state => state.workTime)
export const selectWorkDays = createSelector(selectBase, state => state.workDays)
export const selectCreditRate = createSelector(selectBase, state => state.creditRate)
export const selectAddFilters = createSelector(selectBase, state => state.addFilters)
export const selectGraphColor = createSelector(selectBase, state => state.graphColor)
export const selectButtonColor = createSelector(selectBase, state => state.buttonColor)
export const selectPrivacyPolicy = createSelector(selectBase, state => state.privacyPolicy)
